<template>
    <div class="detail-swiper">
        <Swiper class="swiper">
            <slide v-for="item in topImages">
                <img :src="item">
            </slide>
        </Swiper>
    </div>
</template>

<script>
    import {Swiper,Slide} from '../../../components/common/swiper'
    export default {
        name: "DetailSwiper",
        components:{
            Swiper,
            Slide,
        },
        props:{
            topImages:{
                type:Array,
                default(){
                    return []
                }
            }
        }
    }
</script>

<style scoped>
.swiper{
    height:300px;
    overflow: hidden;
}
</style>